
import Vue from 'vue'
export default ()=>{
    console.log("local",Vue)
    Vue.prototype.$webUrl = 'api/v1/';//测试环境
    Vue.prototype.$uploadUrl = 'http://192.168.50.232:10405/uploadFile' //测试环境上传地址
    Vue.prototype.$downloadUrl = "http://192.168.50.232:8080" //测试环境下载文件地址
    var S4U0201 = "collector";
    var S4U0401 = "usersystem";
    var S4U0402 = "operating";
    var S4U0403 = "goods";
    var S4U0404 = "store";
    var S4U0406 = "imageServer";
    var isUrl = url=> url.indexOf("http") === 0;
    Vue.prototype.$getWebUrl = (scope="")=>{
      scope = scope || "";
      switch(scope.slice(0,4)){
        case "0201":
          return !isUrl(S4U0201) ? Vue.prototype.$webUrl + S4U0201 : S4U0201;
        case "0401":
          return !isUrl(S4U0401) ? Vue.prototype.$webUrl + S4U0401 : S4U0401;
        case "0402":
          return !isUrl(S4U0402) ? Vue.prototype.$webUrl + S4U0402 : S4U0402;
        case "0403":
          return !isUrl(S4U0403) ? Vue.prototype.$webUrl + S4U0403 : S4U0403;
        case "0404":
          return !isUrl(S4U0404) ? Vue.prototype.$webUrl + S4U0404 : S4U0404;
        case "0406":
          return !isUrl(S4U0406) ? Vue.prototype.$webUrl + S4U0406 : S4U0406;
        default:
          return Vue.prototype.$webUrl;
      }
    }
  }